type GlobalThis = Window & typeof globalThis;

export function getGlobal(): GlobalThis {
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  return undefined;
}

export function noStorageSupport(that?: GlobalThis) {
  const globalThis = that ?? getGlobal();
  return (
    typeof globalThis === "undefined" ||
    typeof globalThis.localStorage === "undefined" ||
    typeof globalThis.sessionStorage === "undefined"
  );
}
